import type { I18nMessages } from "@/shared/i18n/types";

export const zhCNMessages: I18nMessages = {
  "agents.page.count": "{count} 个可用 Agent",
  "agents.page.title": "Agents",
  "agentConsole.action.add": "添加",
  "agentConsole.action.cancelEdit": "取消编辑",
  "agentConsole.action.confirmDelete": "确认删除",
  "agentConsole.action.create": "创建智能体",
  "agentConsole.action.delete": "删除",
  "agentConsole.action.new": "新建",
  "agentConsole.action.refresh": "刷新智能体",
  "agentConsole.action.retry": "重试",
  "agentConsole.action.saveChanges": "保存修改",
  "agentConsole.detail.createSubtitle": "保存后写入后端 agent 配置",
  "agentConsole.detail.titleCreate": "新建智能体",
  "agentConsole.detail.titleEdit": "编辑智能体",
  "agentConsole.diagnostics.title": "配置诊断",
  "agentConsole.diagnostics.uneditable": "配置文件无法解析，暂不能用结构化表单保存。请先修复源文件。",
  "agentConsole.empty": "暂无匹配智能体。",
  "agentConsole.error.jsonArray": "{label} 必须是 JSON 数组。",
  "agentConsole.error.jsonInvalid": "{label} JSON 无效：{detail}",
  "agentConsole.error.jsonObject": "{label} 必须是 JSON 对象。",
  "agentConsole.error.keyRequired": "请填写 Agent Key。",
  "agentConsole.error.nameRequired": "请填写名称。",
  "agentConsole.error.structuredSaveUnavailable": "配置源修复前，暂不能用结构化编辑器保存这个智能体。",
  "agentConsole.field.description": "描述",
  "agentConsole.field.mode": "模式",
  "agentConsole.field.name": "名称",
  "agentConsole.field.role": "角色",
  "agentConsole.list.count": "智能体 {count} 个",
  "agentConsole.list.dragHandle": "拖拽排序 {name}",
  "agentConsole.list.savingOrder": "保存排序中...",
  "agentConsole.list.toolsSkills": "工具 {tools} · 技能 {skills}",
  "agentConsole.placeholder.iconImage": "/assets/agent.svg 或 https://...",
  "agentConsole.searchPlaceholder": "搜索智能体...",
  "agentConsole.section.advancedConfig": "高级配置",
  "agentConsole.section.capabilities": "能力",
  "agentConsole.status.invalid": "配置错误",
  "agentConsole.wonders.remove": "删除推荐问题",
  "automationConsole.action.cancelEdit": "取消编辑",
  "automationConsole.action.confirmDelete": "确认删除",
  "automationConsole.action.create": "创建自动化",
  "automationConsole.action.delete": "删除",
  "automationConsole.action.disable": "停用",
  "automationConsole.action.enable": "启用",
  "automationConsole.action.new": "新建",
  "automationConsole.action.refresh": "刷新",
  "automationConsole.action.retry": "重试",
  "automationConsole.action.saveChanges": "保存修改",
  "automationConsole.cronPreset.ariaLabel": "Cron 快捷选择",
  "automationConsole.cronPreset.dailyNine": "每天 09:00",
  "automationConsole.cronPreset.everyFiveMinutes": "每 5 分钟",
  "automationConsole.cronPreset.hourly": "每小时",
  "automationConsole.cronPreset.placeholder": "快捷选择",
  "automationConsole.cronPreset.weekdaySix": "工作日 18:00",
  "automationConsole.detail.createSubtitle": "保存后立即写入后端 automation 配置",
  "automationConsole.detail.titleCreate": "新建自动化",
  "automationConsole.detail.titleEdit": "编辑自动化",
  "automationConsole.empty": "暂无匹配自动化。",
  "automationConsole.error.agentRequired": "请填写 AgentKey。",
  "automationConsole.error.cronFormat": "cron 必须是传统 5 段格式。",
  "automationConsole.error.cronRequired": "请填写 cron。",
  "automationConsole.error.descriptionRequired": "请填写自动化描述。",
  "automationConsole.error.messageRequired": "请填写自动化消息。",
  "automationConsole.error.nameRequired": "请填写自动化名称。",
  "automationConsole.error.paramsJsonInvalid": "Params JSON 无效：{detail}",
  "automationConsole.error.paramsObject": "Params 必须是 JSON 对象。",
  "automationConsole.error.remainingRunsPositive": "剩余次数必须是正整数。",
  "automationConsole.executions.empty": "暂无执行记录。",
  "automationConsole.executions.emptyNoSelection": "保存或选择自动化后查看执行记录。",
  "automationConsole.executions.title": "执行记录",
  "automationConsole.field.agent": "智能体",
  "automationConsole.field.agentPlaceholder": "请选择智能体",
  "automationConsole.field.chatId": "会话ID",
  "automationConsole.field.defaultTimezone": "默认时区",
  "automationConsole.field.description": "描述",
  "automationConsole.field.enabled": "启用自动化",
  "automationConsole.field.hidden": "是否隐藏",
  "automationConsole.field.message": "自动化消息",
  "automationConsole.field.name": "名称",
  "automationConsole.field.params": "参数",
  "automationConsole.field.paramsTooltip": "JSON格式",
  "automationConsole.field.remainingRuns": "剩余次数",
  "automationConsole.field.remainingRunsPlaceholder": "留空表示无限次",
  "automationConsole.field.role": "角色",
  "automationConsole.field.timezone": "时区",
  "automationConsole.filter.status.all": "全部状态",
  "automationConsole.filter.status.disabled": "已停用",
  "automationConsole.filter.status.enabled": "已启用",
  "automationConsole.filter.worker.all": "全部对象",
  "automationConsole.hidden.false": "否",
  "automationConsole.hidden.true": "是",
  "automationConsole.hidden.unset": "不传",
  "automationConsole.list.count": "自动化 {count} 个",
  "automationConsole.list.lastStatus": "最近 {status}",
  "automationConsole.list.nextFire": "下次 {time}",
  "automationConsole.searchPlaceholder": "搜索自动化...",
  "automationConsole.section.request": "请求",
  "automationConsole.status.disabled": "停用",
  "automationConsole.status.enabled": "启用",
  "automationConsole.worker.agent": "智能体 · {id}",
  "automationConsole.worker.team": "团队 · {id}",
  "registryConsole.action.create": "创建配置",
  "registryConsole.action.new": "新建",
  "registryConsole.action.refresh": "刷新",
  "registryConsole.action.refreshFile": "刷新文件",
  "registryConsole.action.retry": "重试",
  "registryConsole.action.save": "保存",
  "registryConsole.action.validate": "校验",
  "registryConsole.capability.function": "函数",
  "registryConsole.capability.reasoner": "推理",
  "registryConsole.capability.vision": "视觉",
  "registryConsole.category.models": "模型",
  "registryConsole.category.mcp-servers": "MCP 服务器",
  "registryConsole.category.providers": "供应商",
  "registryConsole.category.viewport-servers": "视口服务器",
  "registryConsole.category.tools": "工具",
  "registryConsole.confirm.discard": "当前 YAML 有未保存修改，确定丢弃吗？",
  "registryConsole.detail.empty": "请选择或新建 registry 配置。",
  "registryConsole.detail.titleCreate": "新建 registry 配置",
  "registryConsole.editor.label": "YAML 配置",
  "registryConsole.empty": "暂无匹配 registry 配置。",
  "registryConsole.field.category": "分类",
  "registryConsole.field.file": "文件",
  "registryConsole.field.size": "大小",
  "registryConsole.field.updatedAt": "更新时间",
  "registryConsole.filter.category.all": "全部分类",
  "registryConsole.filter.status.all": "全部状态",
  "registryConsole.filter.status.disabled": "已停用",
  "registryConsole.filter.status.invalid": "配置错误",
  "registryConsole.filter.status.ready": "可用",
  "registryConsole.list.count": "配置 {count} 个",
  "registryConsole.message.catalogUpdated": "配置已更新",
  "registryConsole.message.newDraft": "已创建草稿",
  "registryConsole.message.savedWaiting": "已保存，watcher 会自动生效，可刷新查看",
  "registryConsole.message.unsaved": "未保存",
  "registryConsole.message.validationInvalid": "校验发现错误",
  "registryConsole.message.validationReady": "校验通过",
  "registryConsole.meta.toolsCount": "工具 {count} 个",
  "registryConsole.mcpTools.empty.missingServerKey": "工具摘要未提供 serverKey，暂无法归属显示",
  "registryConsole.mcpTools.empty.noTools": "暂无归属于此 MCP 服务器的工具",
  "registryConsole.mcpTools.section.title": "工具列表 {count}",
  "registryConsole.searchPlaceholder": "搜索 registry 配置...",
  "registryConsole.section.categories": "Registry 分类",
  "registryConsole.section.diagnostics": "诊断",
  "registryConsole.section.summary": "摘要",
  "registryConsole.status.disabled": "停用",
  "registryConsole.status.invalid": "错误",
  "registryConsole.status.ready": "可用",
  "registryConsole.searchToolsPlaceholder": "搜索工具名称、key、描述...",
  "registryConsole.tools.empty": "暂无已注册工具",
  "registryConsole.tools.detail.empty": "请选择一个工具查看详情",
  "registryConsole.tools.field.name": "名称",
  "registryConsole.tools.field.key": "Key",
  "registryConsole.tools.field.kind": "调用方式",
  "registryConsole.tools.field.source": "来源",
  "registryConsole.tools.field.sourceType": "来源类型",
  "registryConsole.tools.field.sourceCategory": "来源分类",
  "registryConsole.tools.field.serverKey": "MCP",
  "registryConsole.tools.field.description": "描述",
  "registryConsole.list.count.tools": "工具 {count} 个",
  "toolSource.platform": "内置",
  "toolSource.external": "外部",
  "toolSource.mcp": "MCP",
  "api.downloadFailedWithStatus": "下载失败 ({status})",
  "api.fileDownloadUnsupported": "当前环境不支持文件下载",
  "api.loadResourceTextFailedWithStatus": "加载资源文本失败 ({status})",
  "composer.actions.interrupt": "中断运行",
  "composer.actions.plan": "计划",
  "composer.actions.screenshot": "截屏",
  "composer.actions.screenshotCapturing": "正在截屏...",
  "composer.actions.screenshotDisabled.frontendActive": "前端工具处理中，暂时不能截屏。",
  "composer.actions.screenshotDisabled.streaming": "当前运行中，暂不支持追加截图。",
  "composer.actions.screenshotDisabled.voiceMode": "请先切回文字输入再截屏。",
  "composer.actions.screenshotFailed": "截屏失败",
  "composer.actions.screenshotTimeout": "截屏超时，请重试。",
  "composer.actions.screenshotUnavailable": "截屏不可用",
  "composer.actions.send": "发送",
  "composer.actions.stopVoiceInput": "停止语音输入",
  "composer.actions.upload": "上传文件",
  "composer.actions.uploadDisabled.frontendActive": "前端工具处理中，暂时不能上传文件。",
  "composer.actions.uploadDisabled.streaming": "当前运行中，暂不支持追加文件。",
  "composer.actions.uploadDisabled.voiceMode": "请先切回文字输入再上传文件。",
  "composer.actions.voiceInput": "语音输入",
  "composer.actions.voiceInputDisabled.frontendActive": "前端工具处理中，暂时不能语音输入。",
  "composer.actions.voiceUnavailable": "语音输入不可用",
  "composer.accessLevel.failed": "权限切换请求失败",
  "composer.accessLevel.failedWithDetail": "权限切换请求失败：{detail}",
  "composer.accessLevel.rejected": "当前运行不支持动态切换权限，已恢复为原权限。",
  "composer.accessLevel.rejectedWithDetail": "当前运行不支持动态切换权限（{detail}），已恢复为原权限。",
  "composer.attachments.removeFile": "移除文件 {name}",
  "composer.attachments.viewLeft": "查看左侧附件",
  "composer.attachments.viewRight": "查看右侧附件",
  "composer.awaiting.alreadyResolved": "已被其他终端提交",
  "composer.awaiting.expired": "该操作已过期或失效，已自动恢复",
  "composer.awaiting.unmatched": "提交未命中：{detail}",
  "confirmDialog.loading": "问题生成中...",
  "confirmDialog.validation.date": "请选择有效日期，格式为 {format}",
  "confirmDialog.validation.multiSelect": "请至少选择一个选项",
  "confirmDialog.validation.number": "请输入数字",
  "confirmDialog.validation.select": "请选择一个选项",
  "confirmDialog.validation.text": "请输入内容",
  "composer.background.learn.error": "学习失败",
  "composer.background.learn.pending": "正在学习中...",
  "composer.background.compact.error": "上下文压缩失败",
  "composer.background.compact.pending": "正在压缩上下文...",
  "composer.background.remember.error": "记忆失败",
  "composer.background.remember.pending": "正在记忆中...",
  "composer.input.placeholder.default": "回复消息...（Enter 发送，Shift+Enter 换行）",
  "composer.input.placeholder.expanded": "↵ 键仅用于换行，Esc 可收起输入框",
  "composer.input.placeholder.frontendActive": "前端工具处理中，请在确认面板内提交",
  "composer.input.tooltip.collapse": "收起输入框，用 ↵ 键发送",
  "composer.input.tooltip.expand": "展开输入框，用 ↵ 键换行",
  "composer.query.access.auto_approve": "自动批准",
  "composer.query.access.default": "默认权限",
  "composer.query.access.full_access": "完全访问权限",
  "composer.query.access.title": "设置本次运行权限",
  "composer.query.model.default": "默认模型",
  "composer.query.model.empty": "暂无可选模型",
  "composer.query.model.group": "模型",
  "composer.query.model.loadFailed": "模型加载失败，重新打开可重试",
  "composer.query.model.loading": "正在加载模型...",
  "composer.query.model.saving": "保存中...",
  "composer.query.model.title": "选择模型和思考深度",
  "composer.query.reasoning.HIGH": "高",
  "composer.query.reasoning.LOW": "低",
  "composer.query.reasoning.MAX": "最高",
  "composer.query.reasoning.MEDIUM": "中",
  "composer.query.reasoning.NONE": "关闭",
  "composer.query.reasoning.XHIGH": "超高",
  "composer.query.reasoning.default": "默认思考",
  "composer.query.reasoning.empty": "暂无可选思考深度",
  "composer.query.reasoning.group": "智能",
  "composer.query.serviceTier.FAST": "快速",
  "composer.query.serviceTier.FLEX": "灵活",
  "composer.query.serviceTier.STANDARD": "标准",
  "composer.query.serviceTier.group": "速度模式",
  "composer.speech.error": "语音识别错误：{detail}",
  "composer.speech.listening": "正在听写...",
  "composer.speech.ready": "点击开始听写",
  "composer.speech.retry": "语音识别未启动，请重试",
  "composer.speech.unsupported": "当前浏览器不支持语音输入",
  "composer.steer.cancel": "取消",
  "composer.steer.failed": "引导提交失败：{detail}",
  "composer.steer.rejected": "当前运行没有接受引导（{detail}），已把内容放回输入框。",
  "composer.steer.submit": "引导",
  "composer.steer.unavailable": "当前运行已经不可引导，已把内容放回输入框。",
  "composer.tooltip.createPlan": "创建计划",
  "composer.tooltip.planShortcut": "切换",
  "composer.voice.assistantLabel": "助手回复",
  "composer.voice.assistantPlaceholder": "等待回答...",
  "composer.voice.assistantThinkingPlaceholder": "正在组织回答...",
  "composer.voice.currentWorker": "当前员工：",
  "composer.voice.status.connecting": "正在连接语聊...",
  "composer.voice.status.error": "语聊链路异常",
  "composer.voice.status.listening": "正在听你说话",
  "composer.voice.status.ready": "切换到语聊模式",
  "composer.voice.status.speaking": "正在语音回答",
  "composer.voice.status.thinking": "正在思考回复",
  "composer.voice.title": "语聊中",
  "composer.voice.userLabel": "你刚刚说",
  "composer.voice.userPlaceholder": "等待你开口...",
  "composer.wonders.ariaLabel": "推荐问题",
  "composer.wonders.itemLabel": "推荐问题 {index}",
  "composer.wonders.kicker": "妙问",
  "composer.wonders.title": "试试这些推荐问题",
  "composer.wonders.shuffle": "换一批",
  "composer.wonders.shuffleAriaLabel": "随机换一批推荐问题",
  "copilot.panel.close": "关闭面板",
  "copilot.panel.debug": "调试",
  "copilot.panel.overview": "概览",
  "copilot.panel.preview": "预览",
  "copilot.panel.sourceDetail": "来源",
  "rightSidebar.debug.empty": "暂无事件",
  "rightSidebar.debug.openChat.agent": "Agent",
  "rightSidebar.debug.openChat.agentTitle": "新页面打开 Agent 会话",
  "rightSidebar.debug.openChat.copilot": "Copilot",
  "rightSidebar.debug.openChat.copilotTitle": "新页面打开 Copilot 会话",
  "rightSidebar.debug.tabs.action": "action",
  "rightSidebar.debug.tabs.all": "全部",
  "rightSidebar.debug.tabs.artifact": "artifact",
  "rightSidebar.debug.tabs.awaiting": "awaiting",
  "rightSidebar.debug.tabs.chat": "chat",
  "rightSidebar.debug.tabs.content": "content",
  "rightSidebar.debug.tabs.debug": "debug",
  "rightSidebar.debug.tabs.labelWithCount": "{label} ({count})",
  "rightSidebar.debug.tabs.memory": "memory",
  "rightSidebar.debug.tabs.plan": "plan",
  "rightSidebar.debug.tabs.planning": "planning",
  "rightSidebar.debug.tabs.reasoning": "reasoning",
  "rightSidebar.debug.tabs.request": "request",
  "rightSidebar.debug.tabs.run": "run",
  "rightSidebar.debug.tabs.source": "source",
  "rightSidebar.debug.tabs.task": "task",
  "rightSidebar.debug.tabs.tool": "tool",
  "rightSidebar.overview.artifacts.empty": "暂无产物",
  "rightSidebar.overview.artifacts.title": "产物",
  "rightSidebar.overview.fileChanges.empty": "暂无文件修改",
  "rightSidebar.overview.fileChanges.emptyCoder": "暂无代码修改",
  "rightSidebar.overview.fileChanges.diffEmpty": "暂无差异",
  "rightSidebar.overview.fileChanges.diffLoading": "正在加载差异...",
  "rightSidebar.overview.fileChanges.diffUnavailable": "差异暂不可用",
  "rightSidebar.overview.fileChanges.title": "文件修改",
  "rightSidebar.overview.fileChanges.titleCoder": "代码修改",
  "rightSidebar.preview.actions.close": "关闭",
  "rightSidebar.preview.actions.download": "下载",
  "rightSidebar.preview.error.audio": "音频预览失败，请下载查看。",
  "rightSidebar.preview.error.download": "附件下载失败",
  "rightSidebar.preview.error.image": "图片预览失败，请下载查看。",
  "rightSidebar.preview.error.loadText": "预览加载失败",
  "rightSidebar.preview.error.video": "视频预览失败，请下载查看。",
  "rightSidebar.preview.note": "部分文件的实际预览效果取决于浏览器和后端返回头设置。文本文件仅展示 5MB 的内容，查看完整文件请直接下载。",
  "rightSidebar.preview.office.downloadOnly": "暂不支持预览 Office 文档，请下载后查看。",
  "rightSidebar.preview.text.empty": "文件内容为空",
  "rightSidebar.preview.text.loading": "正在加载文本预览...",
  "rightSidebar.sourceDetail.chunkCount": "共 {count} 个片段",
  "rightSidebar.sourceDetail.chunkLabel": "片段 #{index}",
  "rightSidebar.sourceDetail.empty": "无来源数据",
  "rightSidebar.sourceDetail.selectChunk": "选择一个片段查看详情",
  "rightSidebar.sourceDetail.untitledChunk": "无标题片段",
  "rightSidebar.resize.ariaLabel": "调整右侧栏宽度",
  "rightSidebar.resize.title": "拖拽调整右侧栏宽度",
  "approvalDialog.action.continue": "继续",
  "approvalDialog.action.skip": "跳过",
  "approvalDialog.action.submit": "提交",
  "confirmDialog.action.skip": "跳过",
  "approvalDialog.loading": "等待审批加载中...",
  "approvalDialog.remoteAnswered": "已被其他终端提交",
  "approvalDialog.option.approve": "同意",
  "approvalDialog.option.approve.description": "只本次放行",
  "approvalDialog.option.approveRuleRun": "同意（本次运行同规则都放行）",
  "approvalDialog.option.approveRuleRun.description": "本次 run 内同一规则命中的请求自动放行",
  "approvalDialog.option.reject": "拒绝",
  "approvalDialog.rejectDefaultReason": "拒绝本次审批",
  "approvalDialog.rejectPlaceholder": "请告知如何调整",
  "approvalDialog.selected": "已选",
  "approvalDialog.status.autoSubmitting": "自动提交中...",
  "approvalDialog.timeoutResolved": "等待已超时",
  "approvalDialog.timeout.countdown": "倒计时 {label}",
  "planDialog.option.approve": "是，实施此计划",
  "planDialog.option.reject": "否",
  "planDialog.rejectPlaceholder": "请告知如何调整",
  "planDialog.skipReason": "跳过本次计划实施",
  "planDialog.titleFallback": "实施此计划？",
  "awaiting.action.approve": "同意",
  "awaiting.action.reject": "拒绝",
  "awaiting.action.submit": "提交",
  "awaiting.hint.rejectEditable": "请输入拒绝理由，可以修改表单内容",
  "awaiting.hint.submitEditable": "可以修改表单内容并提交",
  "awaiting.load.failedWithDetail": "业务确认表单加载失败: {detail}",
  "awaiting.load.loading": "加载表单中...",
  "awaiting.load.waiting": "等待业务确认表单加载...",
  "awaiting.remoteAnswered": "已被其他终端提交",
  "awaiting.rejectReason.placeholder": "请输入拒绝理由，可以修改表单内容",
  "awaiting.status.autoSubmitting": "自动提交中...",
  "awaiting.status.collecting": "采集中...",
  "awaiting.status.submitting": "提交中...",
  "awaiting.submit.failedWithDetail": "提交失败：{detail}",
  "awaiting.submit.missingHandler": "提交失败：缺少提交流程处理器",
  "awaiting.timeout.countdown": "提交倒计时 {label}",
  "awaiting.timeoutResolved": "等待已超时",
  "awaiting.title": "业务确认",
  "archive.action.archive": "归档",
  "archive.action.cancel": "取消",
  "archive.action.delete": "删除",
  "archive.action.loadMore": "加载更多",
  "archive.action.restore": "还原",
  "archive.action.restoreAndOpen": "还原并打开",
  "archive.bulk.button": "归档 {count} 条",
  "archive.bulk.confirmContent": "将归档当前筛选范围内 {count} 条超过 {days} 天未更新的会话。",
  "archive.bulk.confirmTitle": "批量归档旧会话",
  "archive.bulk.days": "{days} 天",
  "archive.bulk.dayUnit": "天",
  "archive.bulk.label": "批量归档超过",
  "archive.bulk.result": "已归档 {success} 条。",
  "archive.bulk.resultWithFailures": "已归档 {success} 条，失败 {failed} 条。",
  "archive.deleteConfirm.title": "删除归档记录",
  "archive.detail.archivedAt": "归档于 {time}",
  "archive.empty.detail": "该归档暂无可预览内容。",
  "archive.empty.list": "暂无归档会话。",
  "archive.empty.preview": "(无预览)",
  "archive.empty.select": "选择一条归档会话查看详情。",
  "archive.filter.agentPlaceholder": "按 Agent Key 过滤...",
  "archive.list.ariaLabel": "归档会话",
  "archive.restore.failed": "还原失败",
  "archive.restore.result": "已还原归档会话。",
  "archive.restoreConfirm.title": "还原归档会话",
  "archive.search.placeholder": "搜索归档标题或内容...",
  "archive.item.agent": "智能体",
  "archive.item.created": "创建",
  "archive.item.lastRun": "最后运行",
  "archive.item.updated": "最后活动",
  "archive.tag.attachments": "附件",
  "archive.title": "归档",
  "chatActions.archive.failed": "归档失败",
  "chatActions.archive.menu": "归档",
  "chatActions.archive.ok": "归档",
  "chatActions.archive.title": "归档对话",
  "chatActions.cancel": "取消",
  "chatActions.delete.menu": "删除",
  "chatActions.delete.ok": "删除",
  "chatActions.delete.title": "删除对话",
  "chatActions.export": "导出",
  "chatActions.export.failed": "导出失败",
  "chatActions.export.success": "已导出到下载目录",
  "chatActions.rename.menu": "重命名",
  "chatActions.rename.ok": "保存",
  "chatActions.rename.placeholder": "输入新的对话名称",
  "chatActions.rename.required": "请输入对话名称",
  "chatActions.rename.title": "重命名对话",
  "commandModal.detail.title": "当前详情",
  "commandModal.history.title": "历史对话",
  "commandModal.automation.title": "自动化",
  "commandModal.agents.title": "智能体",
  "commandModal.switch.title": "切换{agentLabel}",
  "globalSearch.placeholder": "搜索智能体、聊天或运行命令",
  "globalSearch.empty": "无匹配结果",
  "globalSearch.action.newConversation": "新建会话",
  "globalSearch.action.history": "历史会话",
  "globalSearch.action.switch": "切换{agentLabel}",
  "globalSearch.action.settings": "设置",
  "globalSearch.action.debug": "调试面板",
  "globalSearch.group.awaiting": "等待中",
  "globalSearch.group.unread": "未读聊天",
  "globalSearch.group.actions": "操作",
  "globalSearch.group.workers": "智能体",
  "globalSearch.group.history": "会话",
  "globalSearch.group.recommended": "推荐",
  "globalSearch.group.agents": "智能体",
  "globalSearch.group.conversations": "会话",
  "globalSearch.row.unread": "未读",
  "contextCompact.completed": "已压缩上下文",
  "contextCompact.compressionRatio": "压缩比：{ratio}%",
  "contextCompact.failed": "上下文压缩失败：{detail}",
  "contextCompact.noHistory": "没有可压缩的历史上下文",
  "contextCompact.originalMessages": "历史消息：{count}",
  "contextCompact.source.deterministicFallback": "规则兜底",
  "contextCompact.source.model": "模型",
  "contextCompact.summarySource": "摘要来源：{source}",
  "contextCompact.toolDigestCount": "工具结果摘要：{count}",
  "contextCompact.unknownError": "未知错误",
  "detail.label.model": "模型",
  "detail.label.name": "名称",
  "detail.label.role": "角色",
  "detail.noValue": "未提供",
  "detail.rawMetadata": "原始元数据",
  "detail.section.members": "成员",
  "detail.section.skills": "技能",
  "detail.section.tools": "工具",
  "desktopFileSystem.browserPathPrompt": "由于浏览器限制，需要输入项目的绝对路径",
  "eventPopover.action.collectSnapshot": "收集事件快照",
  "eventPopover.action.systemPrompt": "System Prompt",
  "eventPopover.close": "关闭事件详情",
  "eventPopover.copy.all": "复制全部",
  "eventPopover.copy.allShort": "全部",
  "eventPopover.copy.arguments": "复制参数",
  "eventPopover.copy.awaitingItems": "复制问题/审批/表单/计划 JSON",
  "eventPopover.copy.collectedSnapshot": "复制汇总快照 JSON",
  "eventPopover.copy.collectedText": "复制汇总文本",
  "eventPopover.copy.currentText": "复制当前文本",
  "eventPopover.copy.error": "复制错误信息",
  "eventPopover.copy.field": "复制 {field}",
  "eventPopover.copy.menuAria": "复制菜单",
  "eventPopover.copy.message": "复制消息",
  "eventPopover.copy.model": "复制 model",
  "eventPopover.copy.openMenu": "打开复制菜单",
  "eventPopover.copy.rawLlmJson": "复制原始 llm json",
  "eventPopover.copy.rawJsonl": "复制原始 jsonl",
  "eventPopover.copy.requestBody": "复制 requestBody",
  "eventPopover.copy.result": "复制结果",
  "eventPopover.copy.sources": "复制来源 JSON",
  "eventPopover.copy.systemPrompt": "复制 systemPrompt",
  "eventPopover.copy.tools": "复制 tools",
  "eventPopover.feedback.copied": "已复制 {label}",
  "eventPopover.feedback.copyFailed": "{label} 复制失败",
  "eventPopover.group.unknown": "未识别分组",
  "eventPopover.meta.time": "时间: {time}",
  "eventPopover.systemPromptModal.callMetaFallback": "无元数据",
  "eventPopover.systemPromptModal.callTitle": "LLM #{index}",
  "eventPopover.systemPromptModal.calls": "LLM 调用",
  "eventPopover.systemPromptModal.close": "关闭 System Prompt",
  "eventPopover.systemPromptModal.empty": "没有找到当前调用的 system prompt 文本。",
  "eventPopover.systemPromptModal.error": "System Prompt 加载失败：{message}",
  "eventPopover.systemPromptModal.loading": "正在加载 System Prompt...",
  "eventPopover.systemPromptModal.timeout": "加载 System Prompt 超时。",
  "eventPopover.systemPromptModal.title": "System Prompt",
  "eventPopover.title.doubleClickCopy": "双击复制全部",
  "leftSidebar.awaitingApproval": "等待审批",
  "leftSidebar.awaitingStatus.plan": "等待实施",
  "leftSidebar.awaitingStatus.question": "等待回答",
  "leftSidebar.awaitingStatus.approval": "等待批准",
  "leftSidebar.awaitingStatus.form": "等待提交",
  "leftSidebar.automationSource": "自动化创建",
  "leftSidebar.browserFolderUnsupported": "当前浏览器不支持选择文件夹",
  "leftSidebar.browserWorkspaceOpenUnavailable": "浏览器导入项目无法打开本机工作目录",
  "leftSidebar.terminalActive": "该智能体有终端",
  "leftSidebar.terminalBusy": "该智能体的终端正在执行命令",
  "leftSidebar.importingProject": "正在导入项目...",
  "leftSidebar.filterChats": "搜索会话...",
  "leftSidebar.filterWorkers": "按 名称 / key / teamId 过滤...",
  "leftSidebar.historyTitle": "历史会话",
  "leftSidebar.historyTitleWithWorker": "{workerTypeLabel}历史会话 · {displayName}",
  "leftSidebar.latestConversationNoReply": "最新会话无答复",
  "leftSidebar.loading": "加载中...",
  "leftSidebar.markAllRead": "全部已读",
  "leftSidebar.moreActions": "更多操作",
  "leftSidebar.newConversation": "新建会话",
  "leftSidebar.noConversations": "暂无会话",
  "leftSidebar.noHistory": "暂无历史会话",
  "leftSidebar.noPreview": "(无预览)",
  "leftSidebar.noRelatedConversations": "暂无相关会话",
  "leftSidebar.noWorkers": "暂无{agentPluralLabel}/{teamPluralLabel}",
  "leftSidebar.openWorkspace": "打开工作目录",
  "leftSidebar.openSettingsMenu": "打开设置菜单",
  "leftSidebar.projectFolderSelectionCanceled": "已取消选择项目文件夹",
  "leftSidebar.settings": "设置",
  "leftSidebar.showMore": "查看更多（共 {count} 条{unreadSuffix}）",
  "leftSidebar.showMoreUnreadSuffix": "，未读 {count} 条",
  "leftSidebar.titleUntitled": "(无标题)",
  "leftSidebar.unread": "未读",
  "leftSidebar.workspaceUnavailable": "当前环境无法访问工作目录",
  "leftSidebar.coderWorkspaceLabel": "工作目录",
  "leftSidebar.workerLabel": "Agent",
  "leftSidebar.renameAgent": "修改名称",
  "leftSidebar.renameAgentPlaceholder": "请输入新名称",
  "leftSidebar.renameAgentSuccess": "名称已修改",
  "leftSidebar.editAgent": "编辑智能体",
  "leftSidebar.deleteAgent": "删除智能体",
  "leftSidebar.deleteAgentConfirm": "确定要删除智能体「{name}」吗？此操作不可撤销。",
  "leftSidebar.createProject.title": "创建项目",
  "leftSidebar.createProject.projectName": "项目名称",
  "leftSidebar.createProject.projectNamePlaceholder": "请输入项目名称",
  "leftSidebar.createProject.projectDirectory": "项目目录",
  "leftSidebar.createProject.projectType": "项目类型",
  "leftSidebar.createProject.useAcp": "使用 ACP",
  "leftSidebar.createProject.acpProxy": "ACP 代理",
  "leftSidebar.createProject.noAcpProxy": "当前没有运行中的 ACP 代理",
  "leftSidebar.createProject.kbaseVectorStore": "向量库",
  "leftSidebar.createProject.kbaseVectorStoreLocal": "本地向量库",
  "leftSidebar.createProject.kbaseVectorStoreRemote": "远程向量库",
  "leftSidebar.createProject.cancel": "取消",
  "leftSidebar.createProject.create": "创建",
  "leftSidebar.createProject.creating": "创建中...",
  "leftSidebar.createProject.nameRequired": "请输入项目名称。",
  "leftSidebar.createProject.kbaseNotImplemented": "KBASE 创建尚未实现。",
  "leftSidebar.createProject.acpRequired": "请选择一个正在运行的 ACP 代理，或关闭 ACP。",
  "leftSidebar.createProject.directoryPlaceholder": "请输入或粘贴项目目录路径",
  "leftSidebar.createProject.directoryRequired": "请输入项目目录路径。",
  "leftSidebar.createProject.creatingProject": "正在创建项目...",
  "automation.action.generateDraft": "生成草稿",
  "automation.example.rule": "例如：每个工作日 18:00",
  "automation.example.task": "例如：每天整理客户日报",
  "automation.hint": "确认后会生成带当前{agentLabel}上下文的草稿，按需再发送。支持 `Ctrl/Cmd + Enter` 快速确认。",
  "automation.label.rule": "执行时间 / 规则",
  "automation.label.task": "任务内容",
  "settings.actions.clearLogs": "清空日志",
  "settings.actions.refreshAgents": "刷新智能体",
  "settings.actions.refreshTeams": "刷新 Teams",
  "settings.asr.backendNotConfigured": "当前语音后端未配置 ASR",
  "settings.asr.clear": "清空结果",
  "settings.asr.fallbackNotice": "capabilities 获取失败，已回退到默认配置",
  "settings.asr.final": "最终转写",
  "settings.asr.finalPlaceholder": "等待 ASR final 文本...",
  "settings.asr.hint": "该调试只验证麦克风音频是否打到 Voice ASR，并展示识别结果，不触发 TTS。",
  "settings.asr.interim": "实时转写",
  "settings.asr.interimPlaceholder": "等待 ASR interim 文本...",
  "settings.asr.label": "ASR Voice 调试",
  "settings.asr.start": "开始录音",
  "settings.asr.status.connecting": "正在连接 ASR...",
  "settings.asr.status.failed": "ASR 调试失败",
  "settings.asr.status.preparing": "正在准备 ASR 调试...",
  "settings.asr.status.recording": "正在录音并发送到 Voice ASR...",
  "settings.asr.status.socketOpen": "ASR WebSocket 已连接，等待后端启动任务...",
  "settings.asr.status.stopping": "正在提交音频并等待最终识别...",
  "settings.asr.stop": "停止并提交",
  "settings.clientGate.enabled": "启用前端本地门限过滤",
  "settings.clientGate.field.closeHoldMs": "Close Hold (ms)",
  "settings.clientGate.field.openHoldMs": "Open Hold (ms)",
  "settings.clientGate.field.preRollMs": "Pre-roll (ms)",
  "settings.clientGate.field.rmsThreshold": "RMS Threshold",
  "settings.clientGate.hint.primary": "rmsThreshold 越大越难触发，适合过滤轻声；open/close 控制开闭稳定性；preRoll 用于避免吞掉开头音节。",
  "settings.clientGate.hint.secondary": "当前配置仅保留在本页会话内，ASR Debug 会立即使用；进行中的语聊会立即更新本地门限；下次 ASR 启动也会继续沿用该配置。",
  "settings.clientGate.label": "前端语音门限 / Client Gate",
  "settings.close": "关闭",
  "settings.conversationMode.chat": "聊天模式",
  "settings.conversationMode.hint": "控制侧边栏优先以员工会话还是普通聊天视角展示，默认使用员工模式。",
  "settings.conversationMode.label": "对话模式",
  "settings.conversationMode.worker": "员工模式",
  "settings.language.enUS": "English",
  "settings.language.hint": "选择默认界面语言。地址栏 lang 参数只临时覆盖当前页面。",
  "settings.language.label": "默认语言",
  "settings.language.zhCN": "中文",
  "settings.shared.errorWithDetail": "错误：{detail}",
  "settings.theme.dark": "深色",
  "settings.theme.hint": "同步切换自定义界面样式和 Ant Design 组件主题，并记住当前选择。",
  "settings.theme.label": "界面主题",
  "settings.theme.light": "浅色",
  "settings.title": "设置",
  "settings.token.hint.app": "App 模式下由宿主应用通过 Bridge 自动管理，用于 API Bearer 与 Voice WS query access_token。",
  "settings.token.hint.web": "用于 API Bearer 与 Voice WS query access_token；仅保存在当前浏览器本地。",
  "settings.token.label": "Access Token",
  "settings.token.placeholder.app": "Token 由宿主应用自动管理",
  "settings.token.placeholder.web": "输入访问令牌...",
  "settings.token.save": "保存",
  "settings.transport.ariaLabel": "传输模式",
  "settings.transport.hint.sse": "当前使用 SSE 查询流，不启用 live 实时同步；普通 API 继续通过 HTTP 可用。",
  "settings.transport.hint.ws": "当前默认使用 WebSocket 传输。{wsStatusText}。",
  "settings.transport.hint.wsStreaming": "当前流式响应中，连接状态由 WebSocket 维持。",
  "settings.transport.label": "传输模式",
  "settings.transport.wsStatus.connected": "WebSocket 已连接",
  "settings.transport.wsStatus.connecting": "WebSocket 连接中...",
  "settings.transport.wsStatus.disconnected": "WebSocket 未连接",
  "settings.transport.wsStatus.error": "WebSocket 连接异常",
  "settings.transport.wsStatus.errorWithDetail": "WebSocket 连接异常：{detail}",
  "settings.tts.label": "TTS Voice 调试",
  "settings.tts.send": "发送并播放",
  "settings.tts.stop": "停止播放",
  "settingsMenu.ariaLabel": "设置菜单",
  "settingsMenu.archive": "归档",
  "settingsMenu.archiveDescription": "查看已归档会话，并批量归档旧会话。",
  "settingsMenu.memoryInfo": "记忆信息",
  "settingsMenu.memoryInfoDescription": "查看当前智能体的记忆记录与完整详情。",
  "settingsMenu.openSettings": "打开设置...",
  "settingsMenu.registries": "注册配置",
  "settingsMenu.registriesDescription": "管理 registry YAML 配置。",
  "settingsMenu.skills": "技能",
  "settingsMenu.skillsDescription": "编辑技能目录、SKILL.md、references 与 scripts。",
  "settingsMenu.reserved.appearance": "外观偏好（即将开放）",
  "settingsMenu.reserved.connection": "连接设置（即将开放）",
  "settingsMenu.reserved.description": "预留菜单入口，后续补充。",
  "settingsMenu.reserved.shortcuts": "快捷键（即将开放）",
  "settingsMenu.section.entry": "设置",
  "settingsMenu.section.reserved": "预留",
  "settingsMenu.status.current": "当前",
  "settingsMenu.summary.theme.darkLabel": "夜",
  "settingsMenu.summary.theme.darkTitle": "当前界面：夜间模式",
  "settingsMenu.summary.theme.lightLabel": "日",
  "settingsMenu.summary.theme.lightTitle": "当前界面：日间模式",
  "settingsMenu.summary.transport.sse": "当前传输模式：SSE",
  "settingsMenu.summary.transport.ws": "当前传输模式：WebSocket",
  "settingsMenu.summary.transport.wsConnected": "当前传输模式：WebSocket（连接已就绪）",
  "settingsMenu.summary.transport.wsConnecting": "当前传输模式：WebSocket（连接中）",
  "settingsMenu.summary.transport.wsError": "当前传输模式：WebSocket（连接异常：{detail}）",
  "settingsMenu.ws.connected": "当前连接状态：WebSocket 已就绪。",
  "settingsMenu.ws.connecting": "当前连接状态：WebSocket 连接中。",
  "settingsMenu.ws.default": "进入完整设置对话框查看连接与主题详情。",
  "settingsMenu.ws.error": "当前连接状态：{detail}",
  "memoryInfo.actions.close": "关闭",
  "memoryInfo.actions.query": "查询",
  "memoryInfo.actions.refresh": "刷新",
  "memoryInfo.currentAgent": "当前 agentKey：{agentKey}",
  "memoryInfo.detail.rawJson": "原始 JSON",
  "memoryInfo.embedding.disabled": "未建立 embedding",
  "memoryInfo.embedding.enabled": "已建立 embedding",
  "memoryInfo.empty.noAgent": "请先选择一个智能体后再查看记忆信息。",
  "memoryInfo.empty.noRecords": "当前筛选条件下暂无记忆记录。",
  "memoryInfo.empty.noSummary": "暂无摘要",
  "memoryInfo.empty.unselected": "从左侧选择一条记录，查看完整字段详情。",
  "memoryInfo.errors.loadDetail": "加载记忆详情失败：{detail}",
  "memoryInfo.errors.loadRecords": "加载记忆记录失败：{detail}",
  "memoryInfo.field.agentKey": "agentKey",
  "memoryInfo.field.category": "分类",
  "memoryInfo.field.chatId": "chatId",
  "memoryInfo.field.confidence": "置信度",
  "memoryInfo.field.createdAt": "创建时间",
  "memoryInfo.field.embedding": "Embedding",
  "memoryInfo.field.id": "ID",
  "memoryInfo.field.importance": "重要度",
  "memoryInfo.field.kind": "Kind",
  "memoryInfo.field.refId": "refId",
  "memoryInfo.field.scopeKey": "scopeKey",
  "memoryInfo.field.scopeType": "scopeType",
  "memoryInfo.field.sourceTable": "来源表",
  "memoryInfo.field.sourceType": "sourceType",
  "memoryInfo.field.status": "状态",
  "memoryInfo.field.summary": "摘要",
  "memoryInfo.field.tags": "标签",
  "memoryInfo.field.updatedAt": "更新时间",
  "memoryInfo.filters.any": "全部",
  "memoryInfo.filters.category": "Category",
  "memoryInfo.filters.categoryPlaceholder": "例如 general / bugfix",
  "memoryInfo.filters.keyword": "关键词",
  "memoryInfo.filters.keywordPlaceholder": "搜索标题 / 摘要 / chatId...",
  "memoryInfo.filters.kind": "Kind",
  "memoryInfo.filters.limit": "Limit",
  "memoryInfo.filters.scopeType": "Scope",
  "memoryInfo.filters.status": "Status",
  "memoryInfo.labels.importanceShort": "重要度 {value}",
  "memoryInfo.loading.detail": "加载详情中...",
  "memoryInfo.loading.records": "加载记忆记录中...",
  "memoryInfo.panel.detail": "记录详情",
  "memoryInfo.panel.detailHint": "查看选中记录的完整字段、embedding 与原始 JSON。",
  "memoryInfo.panel.records": "记忆记录",
  "memoryInfo.rawJson": "Raw JSON",
  "memoryInfo.subtitle": "当前智能体：{label}",
  "memoryInfo.subtitleEmpty": "当前上下文还没有可用的智能体。",
  "memoryInfo.tab": "记忆记录",
  "memoryInfo.title": "记忆信息",
  "memoryPreview.actions.preview": "预览当前输入",
  "memoryPreview.context.agentKey": "agentKey",
  "memoryPreview.context.chatId": "chatId",
  "memoryPreview.context.teamId": "teamId",
  "memoryPreview.empty.disabled": "当前 agent 未启用 memory context。",
  "memoryPreview.empty.noChat": "请先进入一个对话后再预览记忆上下文。",
  "memoryPreview.empty.noDecisions": "当前没有返回选择决策。",
  "memoryPreview.empty.noItems": "这一层没有选中任何记忆。",
  "memoryPreview.empty.noMessage": "请输入当前问题后再预览记忆上下文。",
  "memoryPreview.empty.noPrompt": "这一层没有生成 prompt 文本。",
  "memoryPreview.empty.noResult": "执行一次预览后，就可以查看本次注入的记忆 prompt。",
  "memoryPreview.errors.load": "预览记忆上下文失败：{detail}",
  "memoryPreview.field.message": "当前问题",
  "memoryPreview.field.messagePlaceholder": "默认带入当前 composer 输入，也可以在这里临时微调后再调试。",
  "memoryPreview.layer.observation": "Observation",
  "memoryPreview.layer.session": "Session",
  "memoryPreview.layer.stable": "Stable",
  "memoryPreview.loading.preview": "正在预览记忆上下文...",
  "memoryPreview.panel.input": "预览输入",
  "memoryPreview.panel.inputHint": "这里走和真实 query 一致的 memory recall 路径，但不会调用模型。",
  "memoryPreview.panel.prompt": "Prompt 预览",
  "memoryPreview.panel.promptHint": "按层查看注入的 memory prompt，以及选中的记忆和选择决策。",
  "memoryPreview.section.decisions": "选择决策",
  "memoryPreview.section.selectedMemory": "选中的记忆",
  "memoryPreview.summary.chars": "{count} 字符",
  "memoryPreview.summary.selection": "已选 {selected} / 候选 {candidate}",
  "memoryPreview.summary.snapshotId": "快照 ID",
  "memoryPreview.summary.stopReason": "停止原因",
  "memoryPreview.tab": "Prompt 预览",
  "memoryPreferences.actions.delete": "删除",
  "memoryPreferences.actions.new": "新增偏好",
  "memoryPreferences.actions.save": "保存",
  "memoryPreferences.actions.validate": "校验",
  "memoryPreferences.currentScope": "当前 Scope：{label} · {fileName}",
  "memoryPreferences.editable.no": "只读",
  "memoryPreferences.editable.yes": "可编辑",
  "memoryPreferences.empty.noAgent": "请先选择一个智能体后再查看偏好设置。",
  "memoryPreferences.empty.noPreference": "当前 scope 暂无偏好记录。",
  "memoryPreferences.empty.unselected": "从中间列表选择一条偏好，或点击“新增偏好”。",
  "memoryPreferences.errors.loadScope": "加载 scope 详情失败：{detail}",
  "memoryPreferences.errors.loadScopes": "加载 scope 列表失败：{detail}",
  "memoryPreferences.errors.save": "保存偏好失败：{detail}",
  "memoryPreferences.errors.validate": "校验 markdown 失败：{detail}",
  "memoryPreferences.field.category": "分类",
  "memoryPreferences.field.confidence": "置信度",
  "memoryPreferences.field.createdAt": "创建时间",
  "memoryPreferences.field.id": "ID",
  "memoryPreferences.field.importance": "重要度",
  "memoryPreferences.field.scopeKey": "scopeKey",
  "memoryPreferences.field.scopeType": "scopeType",
  "memoryPreferences.field.status": "状态",
  "memoryPreferences.field.summary": "内容",
  "memoryPreferences.field.tags": "标签",
  "memoryPreferences.field.title": "标题",
  "memoryPreferences.field.updatedAt": "更新时间",
  "memoryPreferences.loading.scope": "加载偏好设置中...",
  "memoryPreferences.meta": "共 {count} 条 · {editable}",
  "memoryPreferences.metaEmpty": "当前 scope 元信息暂不可用。",
  "memoryPreferences.markdown.hint": "Markdown 模式编辑的是 scope 的原始条目格式，不是自由文档。若要写多行说明、列表或代码块，请切到“结构化模式”编辑“内容”。",
  "memoryPreferences.markdown.switchToRecords": "切到结构化模式",
  "memoryPreferences.mode.markdown": "Markdown 编辑",
  "memoryPreferences.mode.records": "结构化模式",
  "memoryPreferences.newRecord": "新偏好",
  "memoryPreferences.notice.unsaved": "当前有未保存更改，请先保存后再切换 scope。",
  "memoryPreferences.notice.validationFailed": "Markdown 校验未通过，请先修正后再保存。",
  "memoryPreferences.panel.detail": "偏好详情",
  "memoryPreferences.panel.detailHint": "查看当前选中偏好的 scope、状态与原始草稿字段。",
  "memoryPreferences.panel.editor": "偏好编辑",
  "memoryPreferences.panel.records": "偏好列表",
  "memoryPreferences.rawJson": "Raw JSON",
  "memoryPreferences.saveSummary": "保存完成：新增 {created} 条，更新 {updated} 条，归档 {archived} 条，未变更 {unchanged} 条。",
  "memoryPreferences.scope.agent": "AGENT",
  "memoryPreferences.scope.global": "GLOBAL",
  "memoryPreferences.scope.team": "TEAM",
  "memoryPreferences.scope.user": "USER",
  "memoryPreferences.tab": "偏好设置",
  "memoryPreferences.validation.expectedKeyValue": "这一行不是受支持的字段格式。Markdown 模式只支持 `- [id] 标题` 和 `key: value`；多行说明、列表或代码块请切到“结构化模式”的“内容”里编辑。",
  "memoryPreferences.validation.error": "第 {line} 行 {field}：{message}",
  "memoryPreferences.validation.field.entry": "条目",
  "memoryPreferences.validation.field.field": "字段格式",
  "memoryPreferences.validation.field.unknown": "未知位置",
  "memoryPreferences.validation.unknown": "未知校验错误",
  "memoryPreferences.validation.warning": "提示 第 {line} 行 {field}：{message}",
  "mermaid.status.failedWithDetail": "Mermaid 图表渲染失败：{detail}",
  "mermaid.status.parseFailed": "Mermaid 语法解析失败。",
  "mermaid.status.receiving": "Mermaid 图表接收中…",
  "mermaid.status.renderFailed": "Mermaid 图表渲染失败。",
  "mermaid.status.rendering": "Mermaid 图表渲染中…",
  "mermaid.status.updating": "更新中…",
  "mermaid.viewport.ariaLabel": "点击放大 Mermaid 图，拖动平移 Mermaid 图",
  "mermaid.viewport.title": "点击放大",
  "mermaid.zoom.in": "放大",
  "mermaid.zoom.inAria": "放大 Mermaid 图",
  "mermaid.zoom.out": "缩小",
  "mermaid.zoom.outAria": "缩小 Mermaid 图",
  "mermaid.zoom.reset": "重置",
  "mermaid.zoom.resetAria": "重置 Mermaid 图缩放",
  "planningTimeline.copy": "复制",
  "planningTimeline.copySuccess": "复制成功",
  "planningTimeline.expand": "展开计划",
  "planningTimeline.implementPlan": "实施计划",
  "planningTimeline.writing": "正在编写计划",
  "route.title.agent": "智能体",
  "route.title.agents": "智能体",
  "route.title.archives": "归档",
  "route.title.automations": "自动化",
  "route.title.memory": "记忆",
  "route.title.registries": "注册配置",
  "route.title.skills": "技能",
  "skillConsole.action.createFile": "新建文件",
  "skillConsole.action.createDir": "新建目录",
  "skillConsole.action.createSkill": "新建技能",
  "skillConsole.action.delete": "删除",
  "skillConsole.action.download": "下载",
  "skillConsole.action.refresh": "刷新",
  "skillConsole.action.replaceFile": "替换文件",
  "skillConsole.action.rename": "重命名",
  "skillConsole.action.retry": "重试",
  "skillConsole.action.save": "保存",
  "skillConsole.action.validate": "校验",
  "skillConsole.confirm.switchFile": "当前文件有未保存的修改，是否放弃？",
  "skillConsole.confirm.switchSkill": "当前技能有未保存的修改，是否放弃？",
  "skillConsole.create.description": "填写技能 Key 和名称，将创建包含 SKILL.md 模板的技能目录。",
  "skillConsole.create.fileNamePlaceholder": "文件名（含扩展名）",
  "skillConsole.create.title": "新建技能",
  "skillConsole.delete.confirm": "确定要删除技能 {name} 吗？此操作不可撤销。",
  "skillConsole.detail.empty": "请在左侧选择一个技能查看详情。",
  "skillConsole.diagnostics.empty": "暂无诊断信息",
  "skillConsole.diagnostics.fileTitle": "文件诊断",
  "skillConsole.diagnostics.title": "技能诊断",
  "skillConsole.editor.language": "语言",
  "skillConsole.editor.readonly": "只读",
  "skillConsole.editor.untitled": "未命名",
  "skillConsole.empty": "暂无技能。",
  "skillConsole.field.fileCount": "文件数",
  "skillConsole.field.key": "Key",
  "skillConsole.field.name": "名称",
  "skillConsole.field.path": "路径",
  "skillConsole.field.size": "大小",
  "skillConsole.field.status": "状态",
  "skillConsole.field.updatedAt": "最近更新",
  "skillConsole.fileOp.createFile": "创建文件",
  "skillConsole.fileOp.createDir": "创建目录",
  "skillConsole.fileOp.delete": "删除",
  "skillConsole.fileOp.deleteConfirm": "确定要删除{type} {name} 吗？",
  "skillConsole.fileOp.rename": "重命名",
  "skillConsole.fileTree.empty": "技能目录为空",
  "skillConsole.fileTree.root": "文件",
  "skillConsole.list.count": "技能 {count} 个",
  "skillConsole.message.noMatch": "无匹配技能。",
  "skillConsole.message.saveFailed": "保存失败",
  "skillConsole.message.saveSuccess": "保存成功",
  "skillConsole.message.unsaved": "有未保存的修改",
  "skillConsole.message.validateInvalid": "校验发现 {count} 个问题",
  "skillConsole.message.validateSuccess": "校验通过",
  "skillConsole.searchPlaceholder": "搜索技能...",
  "skillConsole.statusFilter.all": "全部",
  "skillConsole.statusFilter.disabled": "已禁用",
  "skillConsole.statusFilter.invalid": "无效",
  "skillConsole.statusFilter.ready": "就绪",
  "skillConsole.status.ready": "就绪",
  "skillConsole.status.invalid": "无效",
  "skillConsole.status.disabled": "已禁用",
  "slash.command.debug.description": "切换右侧调试面板或抽屉",
  "slash.command.debug.label": "调试面板",
  "slash.command.detail.description": "查看当前{agentLabel}或{teamLabel}的模型、技能、工具和元数据",
  "slash.command.detail.label": "当前详情",
  "slash.command.history.description": "查看当前{agentLabel}或{teamLabel}的历史会话",
  "slash.command.history.label": "历史会话",
  "slash.command.learn.description": "提炼当前会话中的经验、规则与做法，并提交到学习接口",
  "slash.command.learn.label": "沉淀学习",
  "slash.command.compact.description": "压缩当前会话的历史上下文，保留最近对话和审计记录",
  "slash.command.compact.label": "压缩上下文",
  "slash.command.new.description": "清空当前会话上下文，保留当前 worker 选择",
  "slash.command.new.label": "新会话",
  "slash.command.plan.description": "切换计划模式",
  "slash.command.plan.label": "计划模式",
  "slash.command.remember.description": "记录长期偏好、事实或约束，并提交到记忆接口",
  "slash.command.remember.label": "记录记忆",
  "slash.command.automation.description": "为当前{agentLabel}或{teamLabel}预填自动化草稿",
  "slash.command.automation.label": "自动化",
  "slash.command.settings.description": "打开设置窗口",
  "slash.command.settings.label": "设置",
  "slash.command.switch.description": "搜索并切换当前{agentLabel}或{teamLabel}",
  "slash.command.switch.label": "切换{agentLabel}",
  "slash.command.voice.description": "在文字输入与一问一答语聊模式之间切换",
  "slash.command.voice.label": "语聊模式",
  "slash.command.usage.description": "查看当前会话的 Token 用量与费用统计",
  "slash.command.usage.label": "用量统计",
  "slashPalette.ariaLabel": "斜杠命令",
  "switch.ariaLabel": "切换{agentLabel}",
  "switch.empty": "没有匹配到{agentLabel}或{teamLabel}。",
  "switch.preview.noHistory": "暂无历史会话",
  "switch.scope.all": "全部",
  "switch.scopeLabel": "切换范围",
  "switch.searchPlaceholder": "搜索名称 / key / role...",
  "switch.workerType.agent": "{agentLabel}",
  "switch.workerType.team": "{teamLabel}",
  "timeline.awaitingAnswer.canceled": "已取消等待",
  "timeline.awaitingAnswer.error": "等待异常",
  "timeline.awaitingAnswer.noAnswer": "（无回答内容）",
  "timeline.awaitingAnswer.submitFailed": "提交失败",
  "timeline.awaitingAnswer.submitted": "已提交回答",
  "timeline.awaitingAnswer.timeout": "等待已超时",
  "timeline.agentSwitcher.ariaLabel": "切换智能体，当前为 {name}",
  "timeline.agentSwitcher.empty": "没有匹配的智能体",
  "timeline.agentSwitcher.listAriaLabel": "智能体列表",
  "timeline.agentSwitcher.searchPlaceholder": "搜索智能体名称 / 角色...",
  "timeline.empty.default": "今天有什么可以帮您",
  "timeline.empty.withAgentPrefix": "与 ",
  "timeline.empty.withAgentSuffix": " 对话",
  "timeline.empty.withWorker": "与 {name} 对话",
  "timeline.source.collapse": "收起来源片段",
  "timeline.source.expand": "展开来源片段",
  "timeline.source.locator.line": "第 {start} 行",
  "timeline.source.locator.lineRange": "第 {start}-{end} 行",
  "timeline.source.locator.page": "第 {start} 页",
  "timeline.source.locator.pageRange": "第 {start}-{end} 页",
  "timeline.source.locator.slide": "第 {start} 页幻灯片",
  "timeline.source.locator.slideRange": "第 {start}-{end} 页幻灯片",
  "timeline.source.score": "score {score}",
  "timeline.source.title": "已搜索 {count} 个来源",
  "timeline.time.today": "今天",
  "timeline.time.yesterday": "昨天",
  "timeline.toolPill.copy.action": "复制",
  "timeline.toolPill.copy.copied": "已复制",
  "timeline.toolPill.copy.failed": "复制失败",
  "timeline.toolPill.duration.milliseconds": "{count}毫秒",
  "timeline.toolPill.duration.hours": "{hours}小时{minutes}分{seconds}秒",
  "timeline.toolPill.duration.minutes": "{minutes}分{seconds}秒",
  "timeline.toolPill.duration.seconds": "{count}秒",
  "timeline.toolPill.empty": "空",
  "timeline.toolPill.groupTitle": "{label}",
  "timeline.toolPill.noOutput": "（无输出）",
  "timeline.toolPill.runTitle": "第 {index} 次",
  "timeline.toolPill.status.canceled": "已取消",
  "timeline.toolPill.status.completed": "等待结果",
  "timeline.toolPill.status.failed": "失败",
  "timeline.toolPill.status.pending": "等待中",
  "timeline.toolPill.status.running": "运行中",
  "timeline.toolPill.status.success": "完成",
  "timeline.toolPill.wrap.disable": "禁用自动换行",
  "timeline.toolPill.wrap.enable": "自动换行",
  "timeline.responseDuration.hours": "{hours}小时{minutes}分",
  "timeline.taskStatus.running": "进行中",
  "timeline.taskStatus.completed": "已完成",
  "timeline.taskStatus.failed": "失败",
  "timeline.taskStatus.canceled": "已取消",
  "timeline.taskStatus.default": "任务",
  "timeline.thinking.inProgress": "思考中...",
  "timeline.thinking.title": "思考过程",
  "timeline.query.noText": "无文本提问",
  "timeline.query.resend": "重问",
  "timeline.query.resendInNewChat": "新对话重问",
  "timeline.run.processed": "已处理 {duration}",
  "timeline.run.responseDuration": "响应耗时 {duration}",
  "timeline.run.deriveChat": "派生新会话",
  "timeline.run.deriveChatSuccess": "已派生新会话",
  "timeline.run.deriveChatFailed": "派生新会话失败",
  "timeline.feedback.downvote": "点踩",
  "timeline.feedback.clearDownvote": "取消点踩",
  "timeline.feedback.downvoted": "已点踩",
  "timeline.feedback.cleared": "已取消点踩",
  "timeline.feedback.title": "反馈（选填）",
  "timeline.feedback.placeholder": "我们想知道你对此回答不满意的原因，你认为更好的回答是什么？",
  "timeline.feedback.submit": "提交",
  "platformError.category.auth": "登录状态或权限校验失败，请重新登录或联系管理员。",
  "platformError.category.chat_run": "运行失败，请稍后重试。",
  "platformError.category.model": "模型服务请求失败，请稍后重试。",
  "platformError.category.protocol": "连接协议异常，请稍后重试。",
  "platformError.category.request": "请求无效，服务无法处理当前请求。",
  "platformError.category.system": "服务内部错误，请稍后重试。",
  "platformError.category.timeout": "操作超时，请稍后重试。",
  "platformError.code.active_run_conflict": "当前会话已有运行正在进行。",
  "platformError.code.forbidden": "没有权限执行该操作。",
  "platformError.code.internal_error": "服务内部错误，请稍后重试。",
  "platformError.code.invalid_request": "请求无效，服务无法处理当前请求。",
  "platformError.code.provider_auth_failed": "模型服务鉴权失败，请联系管理员检查 API Key。",
  "platformError.code.provider_bad_response": "模型服务返回异常，请稍后重试。",
  "platformError.code.provider_content_filter": "模型服务拒绝了当前内容，请调整输入后重试。",
  "platformError.code.provider_context_length_exceeded": "上下文过长，已超过模型限制，请减少输入或开启压缩。",
  "platformError.code.provider_model_not_found": "模型服务中不存在该模型，请切换模型或检查配置。",
  "platformError.code.provider_network_error": "连接模型服务失败，请稍后重试。",
  "platformError.code.provider_permission_denied": "模型服务权限不足，请联系管理员检查模型或账号权限。",
  "platformError.code.provider_quota_exhausted": "模型服务额度已用尽，请更换模型或联系管理员检查 API Key / 额度。",
  "platformError.code.provider_rate_limited": "模型服务请求过于频繁，请稍后重试。",
  "platformError.code.provider_request_failed": "模型服务请求失败。",
  "platformError.code.provider_timeout": "模型服务响应超时，请稍后重试。",
  "platformError.code.provider_unavailable": "模型服务暂时不可用，请稍后重试。",
  "platformError.code.run_not_found": "运行不存在或已结束。",
  "platformError.code.run_timeout": "运行超时，请稍后重试。",
  "platformError.code.service_unavailable": "服务暂时不可用，请稍后重试。",
  "platformError.code.stream_failed": "运行流失败，请稍后重试。",
  "platformError.code.too_many_observers": "观察者数量过多，请稍后重试。",
  "platformError.code.too_many_streams": "活跃流数量过多，请稍后重试。",
  "platformError.code.unauthorized": "未登录或登录已过期，请重新登录。",
  "platformError.code.unavailable": "服务暂时不可用，请稍后重试。",
  "platformError.detail.category": "分类",
  "platformError.detail.code": "错误码",
  "platformError.detail.message": "原始消息",
  "platformError.detail.retryable": "可重试",
  "platformError.detail.scope": "范围",
  "platformError.detail.status": "状态码",
  "platformError.generic": "操作失败，请稍后重试。",
  "platformError.retryableHint": "可以稍后重试。",
  "platformError.special.channelNotConnected": "服务通道未连接，请检查后端通道状态。",
  "platformError.technicalDetails": "技术详情",
  "topNav.audio.mute": "静音语音输出",
  "topNav.audio.unmute": "取消静音",
  "topNav.debug.close": "关闭调试面板",
  "topNav.debug.open": "打开调试面板",
  "topNav.newConversation": "开始新会话",
  "topNav.newProject": "新建项目",
  "topNav.noSelection": "未选择{agentLabel}",
  "topNav.openDrawer": "打开会话列表",
  "topNav.status.error": "运行异常",
  "topNav.status.idle": "待命",
  "topNav.status.running": "运行中",
  "topNav.terminal.close": "关闭终端面板",
  "topNav.terminal.open": "打开终端面板",
  "topNav.usage.close": "关闭用量统计",
  "topNav.usage.cacheHitRate": "缓存命中率",
  "topNav.usage.compact": "压缩",
  "topNav.usage.contextWindow": "上下文窗口",
  "topNav.usage.estimatedNext": "预计下次调用 {value}",
  "topNav.usage.metric.cacheHit": "缓存命中",
  "topNav.usage.metric.cacheMiss": "缓存未命中",
  "topNav.usage.metric.completion": "输出",
  "topNav.usage.metric.firstTokenLatency": "首字延迟",
  "topNav.usage.metric.llmCalls": "LLM 调用",
  "topNav.usage.metric.outputTokensPerSecond": "输出速度",
  "topNav.usage.metric.prompt": "输入",
  "topNav.usage.metric.reasoning": "推理",
  "topNav.usage.metric.toolCalls": "工具调用",
  "topNav.usage.metric.total": "总计",
  "topNav.usage.modelUnknown": "未知模型",
  "topNav.usage.open": "打开用量统计",
  "topNav.usage.section.chat": "会话累计",
  "topNav.usage.section.compact": "上下文压缩",
  "topNav.usage.section.current": "本次调用",
  "topNav.usage.section.run": "最新运行累计",
  "topNav.usage.title": "用量统计",
  "topNav.usage.totalCost": "总花费",
  "topNav.usage.totalShort": "{total} tokens",
  "topNav.usage.waiting": "等待用量统计事件...",
  "topNav.usage.waitingShort": "用量",
  "topNav.voice.hangup": "挂断语聊",
  "topNav.voice.hangupWithShortcut": "挂断语聊 (Esc)",
  "topNav.voice.open": "打开语聊",
  "topNav.voice.openWithShortcut": "打开语聊 ({shortcut})",
  "voice.chat.error.asrFailure": "ASR 失败",
  "voice.chat.error.asrNotConfigured": "当前语音后端未配置 ASR，语聊模式不可用",
  "voice.chat.error.connectionFailed": "语音 WebSocket 连接失败",
  "voice.chat.error.invalidVoicesResponse": "语音后端音色列表返回格式异常",
  "voice.chat.error.linkRecoveryFailed": "语音链路恢复失败: {reason}",
  "voice.chat.error.noSelectedVoice": "当前语音后端未返回可用音色",
  "voice.chat.error.reconnectStartAsrFailed": "语音 WebSocket 重连后无法启动 ASR",
  "voice.chat.error.streamTtsNotEnabled": "当前语音后端未开启流式 TTS 输入，语聊模式不可用",
  "voice.chat.error.taskStopped": "语音识别任务已停止",
  "voice.chat.error.voiceSocketNotConnected": "语音 WebSocket 尚未连接",
  "agentRoute.loading.agent": "正在加载智能体",
  "agentRoute.loading.chat": "正在加载会话",
  "leftSidebar.quickActions.agents": "智能体",
  "leftSidebar.quickActions.automation": "自动化",
  "leftSidebar.quickActions.memory": "记忆",
  "voice.debug.defaultTtsText": "这是一条 TTS 调试语音。如果你能听到这句话，说明当前语音播放链路正常。",
  "ws.connectionFailedWithMessage": "WebSocket 连接失败：{message}",
  "ws.disconnected": "WebSocket 连接已断开，请稍后重试。",
  "ws.handshakeFailed": "WebSocket 握手失败，请检查 Access Token 是否有效，并确认后端已启用 /ws。",
  "ws.heartbeatTimeout": "WebSocket 心跳超时，连接已自动重连，请重试当前请求。",
  "ws.missingAccessToken.browser": "缺少 Access Token，无法建立 WebSocket 连接。请先在设置中填写有效令牌。",
  "ws.missingAccessToken.host": "缺少 Access Token，无法建立 WebSocket 连接。请确认宿主应用已提供有效令牌。",
  "ws.transportNotInitialized": "WebSocket 传输尚未初始化，请先切换到 WebSocket 模式并确认连接成功。",
  "logoLoading.text": "加载中...",
};
